import React from 'react';
import { BaseComponent } from "../base/BaseComponent";
import { Button, Modal } from "react-bootstrap";

interface ConfirmClearDialogProps {
    show: boolean;
    title: string;
    text: string;
    onCancel?: () => void;
    onConfirm?: () => void;
}
export class ConfirmClearDialog extends BaseComponent<ConfirmClearDialogProps, {}> {
    render() {
        return (
            <Modal show={this.props.show}>
            <Modal.Header closeButton>
                <Modal.Title>{this.props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {this.props.text}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.props.onCancel}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={this.props.onConfirm}>
                    Ok
                </Button>
            </Modal.Footer>
        </Modal>
        );
    }
}
